import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Modal } from '../../../components/Modal';
import { GeneratePdfButton } from '../../../components/GeneratePdfButton/GeneratePdfButton';
import { HBox, VBox } from '../../../components/Box';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../constants';
import { selectAllOptions } from '../selectors';
import { selectWork } from '../../Api/selectors';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { selectHomeCompany } from '../../Companies/selectors';
import { CompanyLabel } from '../../Companies/components/CompanyLabel';
import { formatLicensePlate } from '../../../utils/string';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../Companies/translate-countries';

dayjs.extend(customParseFormat);

const Container = styled.div`
  font-size: 16px !important;
  margin: 10px auto;
  font-family: 'nunito', sans-serif;
  width: 1240px;
  height: 1754px;
  background-color: white;

  .doc-main {
    color: black;
    font-weight: 500;
    font-size: 16px;
    padding: 110px 150px 75px 150px;
  }

  .loaction-block {
    margin-bottom: 40px;
    font-size: 16px !important;
  }

  .country-location-block {
    margin-bottom: 60px;
  }

  .documentd-block {
    min-height: 55px;
    max-height: 55px;
    margin-bottom: 72px;
  }
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class CMRPreviewComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  get date() {
    const date = new Date(this.props.data?.takeOver?.date)?.toISOString();
    const result = dayjs(date)?.format('DD-MM-YYYY');
    return result;
  }

  get homeId() {
    return this.props.homeCompanyId;
  }

  get locale() {
    return this.props.locale;
  }

  titleWrapper(text) {
    const string = `{${text}}`;
    return string;
  }

  render() {
    const { vehicle, data } = this.props;
    const sender = data?.sender;
    const consignee = data?.consignee;
    const transporter = data?.transporter;
    const isIndeWal = sender.address?.postcode != "8028 PR";
    const styles = {
      marginTop: '400px',
      color: 'white',
      marginLeft: isIndeWal ? '600px' : 'initial',
    };

    const AddressBlock = ({ isGMBH, styles }) => {
      return sender.address?.postcode == "47652" ? (
        <div className="location-block" style={{marginTop:'400px', color:'blue'}}>
          <div>In de Wal GmbH</div>
          <div>Limburger Tor 114-117</div>
          <div>47652 Weeze</div>
          <div>Tel: 0880038000</div>
        </div>
      ) : (
        <div className="location-block" style={styles}>
          <div>In de Wal auto's</div>
          <div>Kleefstraat 8</div>
          <div>8028 PR Zwolle</div>
          <div>Tel: 0880038000</div>
          <div>NL800234903B01</div>
        </div>
      );
    };

    return (
      <Modal pdfView onClose={this.props.onClose}>
        <Container>
          <VBox id={'CMR_doc'} className="doc-main">
            <HBox left className="loaction-block">
              <VBox>
                {sender?.address?.company_name ? (
                  <HBox vCenter left>
                    <span className="company-label">{sender?.address?.company_name}</span>
                  </HBox>
                ) : (
                  <HBox vCenter left>
                    <div style={{ fontSize: '16px' }}>
                    <CompanyLabel company={sender?.company} />
                    </div>
                  </HBox>
                )}
                <VBox left>
                <div style={{ fontSize: '16px' }}>
                {sender.address?.addressLine1}</div>
                <div style={{ fontSize: '16px' }}>
                    {sender.address?.postcode} {sender.address?.city}
                  </div>
                  <div style={{ fontSize: '16px' }}>{translateCountry(sender.address?.country?.name, this.locale)}</div>
                </VBox>
              </VBox>
            </HBox>
            <HBox className="loaction-block" style={{ marginBottom: '62px' }}>
              <VBox>
                {/* <HBox vCenter left>
                  {this.lbl(`address.type.${consignee.address?.type?.name || 'other'}`)}
                  &nbsp;
                </HBox> */}
                {consignee?.address?.company_name ? (
                  <HBox vCenter left>
                    <div style={{ fontSize: '16px' }}>
                    <span className="company-label">{consignee?.address?.company_name}</span>
                    </div>
                  </HBox>
                ) : (
                  <HBox vCenter left>
                    <div style={{ fontSize: '16px' }}>
                    <CompanyLabel company={consignee?.company} />
                    </div>
                  </HBox>
                )}
                <VBox left>
                <div style={{ fontSize: '16px' }}>{consignee?.address?.addressLine1}</div>
                <div style={{ fontSize: '16px' }}>
                    {consignee?.address?.postcode} {consignee?.address?.city}
                  </div>
                  <div style={{ fontSize: '16px' }}>{translateCountry(consignee?.address?.country?.name, this.locale)}</div>
                </VBox>
              </VBox>
              <VBox style={{ marginLeft: '200px' }}>
                {transporter?.address?.company_name ? (
                  <HBox vCenter left>
                    <div style={{ fontSize: '16px' }}>
                    <span className="company-label">{transporter?.address?.company_name}</span>
                    </div>
                  </HBox>
                ) : (
                  <HBox vCenter left>
                    <div style={{ fontSize: '16px' }}>
                    <CompanyLabel company={transporter?.company} />
                    </div>
                  </HBox>
                )}
                <VBox left>
                <div style={{ fontSize: '16px' }}>{transporter.address?.addressLine1}</div>
                <div style={{ fontSize: '16px' }}>
                    {transporter.address?.postcode} {transporter.address?.city}
                  </div>
                  <div style={{ fontSize: '16px' }}>{translateCountry(transporter.address?.country?.name, this.locale)}</div>
                </VBox>
              </VBox>
            </HBox>
            <VBox left className="country-location-block">
            <div style={{ fontSize: '16px' }}>{consignee.address?.city}</div>
            <div style={{ fontSize: '16px' }}>{translateCountry(consignee?.address?.country?.name, this.locale)}</div>
            </VBox>

            <VBox left className="loaction-block">
            <div style={{ fontSize: '16px' }}>{data.takeOver?.city}</div>
            <div style={{ fontSize: '16px' }}>{this.date != '01-01-1970' && this.date}</div>
            </VBox>

            <VBox left className="loaction-block documentd-block" style={{ maxWidth: '50%', justifyContent: 'center' }}>
            <div style={{ fontSize: '16px' }}>
              <pre>{data?.documents}</pre>
            </div>
            </VBox>
            <div style={{ height: '390px', overflowY: 'auto', width: '100%', fontSize: '16px' }}>

            <VBox >
  {data?.vehicleList?.map(vehicle => {
    return (
    
      <HBox key={vehicle?.id} vCenter style={{ width: '80%', marginBottom: '10px' }}>
       <div style={{ fontSize: '16px' }}><strong>{vehicle?.vin}</strong></div>
       <div style={{ fontSize: '16px' }}>  <span>{formatLicensePlate(vehicle?.regplate)}</span></div>
        <HBox style={{ width: '40%' }}>
        <div style={{ fontSize: '16px' }}> <span>{`${vehicle?.brand_name}`}&nbsp;</span></div>
        <div style={{ fontSize: '16px' }}> <span>{`${vehicle?.model_name}`}</span></div>
        </HBox>
       
      </HBox>
    );
  })}
</VBox>
</div>
<div style={{ fontSize: '16px' }}>
<AddressBlock isGMBH={true} styles={styles} />            
</div>
              
          </VBox>
        </Container>
        <GeneratePdfButton sectionId={'CMR_doc'} label={'PDF'} widthMn={210} heightMm={297} />
      </Modal>
    );
  }
}

CMRPreviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vehicle: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loadingChecks: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    allOptions: selectAllOptions(),
    homeCompanyId: selectHomeCompany(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CMRPreview = compose(withConnect, withRouter)(CMRPreviewComp);
